  function osVal(id) {
    return parseFloat(document.getElementById(id).value) || 0;
  }

  function osGoStep2() {
    let l = osVal("os-length");
    let w = osVal("os-width");
    let h = osVal("os-height");
    let windowArea = osVal("os-windowArea");

    let netWalls = ((l * h * 2) + (w * h * 2)) - windowArea;
    let ceiling = l * w;
    let floor = ceiling;
    let infil = l * w * h;

    document.getElementById("os-window").value = windowArea;
    document.getElementById("os-net").value = netWalls.toFixed(2);
    document.getElementById("os-ceiling").value = ceiling.toFixed(2);
    document.getElementById("os-floor").value = floor.toFixed(2);
    document.getElementById("os-infil").value = infil.toFixed(2);

    document.getElementById("os-step1").style.display = "none";
    document.getElementById("os-step2").style.display = "block";
  }

  function osCalculate() {
    let windowHL = osVal("os-window") * osVal("os-windowHM");
    let wall = osVal("os-net") * osVal("os-wallHM");
    let ceiling = osVal("os-ceiling") * osVal("os-ceilingHM");
    let floor = osVal("os-floor") * osVal("os-floorHM");
    let infil = osVal("os-infil") * osVal("os-infilHM");

    let total = windowHL + wall + ceiling + floor + infil;

    // BTU recommendation logic
    let btu = total;
    let data = [
      { min: 0,     max: 2500,    range: "1,500–2,500 BTU",  rad: "4 Tube × 5–6 Sections",   best: "Bathrooms / Hallways" },
      { min: 2500,  max: 4000,    range: "2,500–4,000 BTU",  rad: "4 Tube × 7–8 Sections",   best: "Small Bedrooms" },
      { min: 4000,  max: 6000,    range: "4,000–6,000 BTU",  rad: "4 Tube × 9–10 Sections",  best: "Bedrooms / Offices" },
      { min: 6000,  max: 8000,    range: "6,000–8,000 BTU",  rad: "4 Tube × 11–12 Sections", best: "Medium Bedrooms" },
      { min: 8000,  max: 10000,   range: "8,000–10,000 BTU", rad: "6 Tube × 10–12 Sections", best: "Kitchens / Dens" },
      { min: 10000, max: 12000,   range: "10,000–12,000 BTU",rad: "6 Tube × 12–15 Sections", best: "Living Rooms" },
      { min: 12000, max: 15000,   range: "12,000–15,000 BTU",rad: "6 Tube × 15–18 Sections", best: "Large Living Areas" },
      { min: 15000, max: Infinity,range: "15,000+ BTU",       rad: "6 Tube × 18+ Sections",  best: "Large Rooms / Commercial" }
    ];

    let match = data.find(d => btu >= d.min && btu < d.max);
    if (match) {
      document.getElementById("os-btuRange").innerText = match.range;
      document.getElementById("os-radSize").innerText  = match.rad;
      document.getElementById("os-bestFor").innerText  = match.best;
    }

    // Row values
    document.querySelector(".os-window-area").innerText = osVal("os-window").toFixed(2);
    document.querySelector(".os-window-hm").innerText   = osVal("os-windowHM").toFixed(2);
    document.querySelector(".os-window-hl").innerText   = windowHL.toFixed(2);

    document.querySelector(".os-wall-area").innerText   = osVal("os-net").toFixed(2);
    document.querySelector(".os-wall-hm").innerText     = osVal("os-wallHM").toFixed(2);
    document.querySelector(".os-wall-hl").innerText     = wall.toFixed(2);

    document.querySelector(".os-ceiling-area").innerText = osVal("os-ceiling").toFixed(2);
    document.querySelector(".os-ceiling-hm").innerText   = osVal("os-ceilingHM").toFixed(2);
    document.querySelector(".os-ceiling-hl").innerText   = ceiling.toFixed(2);

    document.querySelector(".os-floor-area").innerText  = osVal("os-floor").toFixed(2);
    document.querySelector(".os-floor-hm").innerText    = osVal("os-floorHM").toFixed(2);
    document.querySelector(".os-floor-hl").innerText    = floor.toFixed(2);

    document.querySelector(".os-infil-area").innerText  = osVal("os-infil").toFixed(2);
    document.querySelector(".os-infil-hm").innerText    = osVal("os-infilHM").toFixed(2);
    document.querySelector(".os-infil-hl").innerText    = infil.toFixed(2);

    // Totals
    document.getElementById("os-t60").innerText  = total.toFixed(2);
    document.getElementById("os-t70").innerText  = (total * 1.18).toFixed(2);
    document.getElementById("os-t80").innerText  = (total * 1.34).toFixed(2);
    document.getElementById("os-t90").innerText  = (total * 1.50).toFixed(2);
    document.getElementById("os-t100").innerText = (total * 1.66).toFixed(2);

    document.getElementById("os-step2").style.display = "none";
    document.getElementById("os-step3").style.display = "block";
  }

  function osResetAll() {
    location.reload();
  }

  // ---- Event Listeners (no inline onclick) ----
  document.getElementById("os-btn-input-data").addEventListener("click", osGoStep2);
  document.getElementById("os-btn-clear-step1").addEventListener("click", osResetAll);
  document.getElementById("os-btn-calculate").addEventListener("click", osCalculate);
  document.getElementById("os-btn-reenter").addEventListener("click", osResetAll);
  document.getElementById("os-btn-recalculate").addEventListener("click", osResetAll);
